import { authTokenAxios, schoolTokenAxios } from "../axios";

const REPORTING_BASE = process.env.REACT_APP_SCHOOL_REPORTING_BASE;
const SCHOOL_BASE = process.env.REACT_APP_SCHOOL_BASE;
let reporting_url = `${REPORTING_BASE}`;


export const getWA_TemplateById = (waTemplateId) => {
  return schoolTokenAxios.get(`${reporting_url}/waTemplate/listWA_Mapping`, {
    params: { id: waTemplateId },
  });
};

// Map WA Template with Purpose 
export const map_Wa_TemplateWithPurpose = (data) => {
  return schoolTokenAxios.post(`${reporting_url}/waTemplate/map_Wa_TemplateWithPurpose`, data);
}

// update WA Template
export const updateWA_Template = (waTemplateId, data) => {
  return schoolTokenAxios.put(
    `${reporting_url}/waTemplate/${waTemplateId}`,
    data
  );
};

export const deleteWA_Template = (waTemplateId) => {
  return schoolTokenAxios.delete(`${reporting_url}/waTemplate/${waTemplateId}`);
};

export const getVLwaConfigBySchool = () => {
  return schoolTokenAxios.get(`${SCHOOL_BASE}/com/wa/getVLwaConfigBySchool`);
};
export const upsertVLwaConfig = (payload) => {
  return schoolTokenAxios.put(
    `${SCHOOL_BASE}/com/wa/upsertVLwaConfig`,
    payload
  );
};

export const listWhatsAppVariables = (purpose) => {
  return authTokenAxios.get(
    `${REPORTING_BASE}/waTemplate/listWhatsAppVariables`,
    {
      params: { purpose },
    }
  );
};